export const getParameterByName = (name, url) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const illegalCharactersInWord = (regex, word) => [...word].filter(letter => !regex.test(letter));

export const browserIsIE11 = !!window.MSInputMethodContext && !!document.documentMode;

export const alphabeticSortByName = (a, b) => a.name.localeCompare(b.name);

export { validatePesel, calculateBirthdayFromPesel, calculateGenderFromPesel } from 'braster-frontend-utils';



// WEBPACK FOOTER //
// ./src/utils.js